import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const GotoTop = props => (
  <button
    className={`scroll-to-top ${Styles.button}`}
    onClick={() => props.handleGotoTop(props.offset, props.options)}
  >
    <i className="icon-arrow-up" />
  </button>
)

GotoTop.defaultProps = {
  options: {},
  offset: 0,
}

GotoTop.propTypes = {
  offset: PropTypes.number.isRequired,
  options: PropTypes.shape({

  }).isRequired,
  handleGotoTop: PropTypes.func.isRequired,
}

export default GotoTop
